import styled from "styled-components";

const Style = styled.div`
  .ant-tag-red span {
    color: #cf1322;
  }
  
  .ant-tag-green span {
    color: #389e0d;
  }
`

export default function ModuleTags({ children }) {
  return (
    <Style className="flex flex-row justify-content-center module-tags">
      {children}
    </Style>
  )
}
